"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.MultiCodeBlock = exports.MultiCodeBlockContext = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("@chakra-ui/react");
var CodeBlock_1 = require("./CodeBlock");
var FiChevronDown_1 = require("@react-icons/all-files/fi/FiChevronDown");
exports.MultiCodeBlockContext = (0, react_1.createContext)(null);
function getLanguage(language) {
    switch (language) {
        case 'language-js':
        case 'language-jsx':
        case 'language-javascript':
            return 'JavaScript';
        case 'language-ts':
        case 'language-tsx':
        case 'language-typescript':
            return 'TypeScript';
        default:
            return language;
    }
}
var MultiCodeBlock = function (_a) {
    var children = _a.children;
    var codeBlocks = react_1["default"].Children.toArray(children).reduce(function (acc, child) {
        var _a;
        return (0, react_1.isValidElement)(child)
            ? __assign(__assign({}, acc), (_a = {}, _a[getLanguage(child.props.children.props.className)] = child, _a)) : acc;
    }, {});
    var languages = Object.keys(codeBlocks);
    var defaultLanguage = languages[0];
    var _b = (0, react_1.useContext)(exports.MultiCodeBlockContext), language = _b.language, setLanguage = _b.setLanguage;
    var renderedLanguage = languages.includes(language)
        ? language
        : defaultLanguage;
    return (react_1["default"].createElement("div", null,
        react_1["default"].createElement(CodeBlock_1.CodeBlockContext.Provider, { value: react_1["default"].createElement(react_2.Menu, null,
                react_1["default"].createElement(react_2.MenuButton, { as: react_2.Button, rightIcon: react_1["default"].createElement(FiChevronDown_1.FiChevronDown, null) }, renderedLanguage),
                react_1["default"].createElement(react_2.MenuList, null, languages.map(function (language) { return (react_1["default"].createElement(react_2.MenuItem, { key: language, onClick: function () {
                        var _a;
                        setLanguage(language);
                        (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'Change language', {
                            event_category: CodeBlock_1.GA_EVENT_CATEGORY_CODE_BLOCK,
                            event_label: language
                        });
                    } }, language)); }))) }, codeBlocks[renderedLanguage])));
};
exports.MultiCodeBlock = MultiCodeBlock;
